// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSupplyforce: React.FC<{ width?: number; height?: number }> = ({ width = 70, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.523 10.94h33.342L36.628 0zM0 13.06 30.565 24l2.764-10.94zm36.695-2.12H70L39.453.011zm-.541 2.12-2.752 10.928 36.05-10.928z"
            />
        </svg>
    );
};

export default React.memo(FooterSupplyforce);
